import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayFieldGetter',
  pure: true
})
export class ArrayFieldGetterPipe implements PipeTransform {

  transform(value: any[], fieldToGet: string): string[] {
    return value ? value.map((item) => item[fieldToGet]) : [];
  }

}
